export class Queuedata {
  constructor(_queueID, _segmentID, _serviceID)
  {
    this.queueID = _queueID;
    this.segmentID = _segmentID || null;
    this.serviceID = _serviceID || null;
  }
}